(function (){
  const constant = window.hanlin.constant

  const createIndexTemplate = () => {
    return `
      <link rel="stylesheet" href="../../../css/reset.css">
      <link rel="stylesheet" href="../../../css/all.css">
      <link rel="stylesheet" href="../../../css/table.css">
      <link rel="stylesheet" href="../../../css/index.css">
      <footer>
          <article>
            <ul>
              <li class="hle_logo">翰林出版</li>
              <li><a href="https://books.hanlin.com.tw/" target="_blank" class="bookTown">翰林書城</a> |</li>
              <li><a href="https://books.hanlin.com.tw/Dealer" target="_blank">經銷商據點</a> |</li>
              <li><a href="https://books.hanlin.com.tw/Version" target="_blank">版本查詢</a> |</li>
              <li><a href="https://url-m01d.hle.com.tw/footer-files" target="_blank">檔案下載區</a> |</li>
              <li><a href="https://url-m01d.hle.com.tw/footer-sample" target="_blank">試閱區</a> |</li>
              <li><a href="https://docs.google.com/document/d/1JmQQOWM73oQcBgpVU_ucfmvoNPkKtmenUG2_rMRs2Fs/edit?usp=sharing" target="_blank">勘誤補充</a> |</li>
              <li>
                <a href="https://www.facebook.com/hanlinppbox/"><span class="share_fb"></span></a>
              </li>
            </ul>
            <p><span>2023 Hanlin 翰林出版事業股份有限公司</span>
              <em class="v_nber">v3.0.2</em>
            </p>
            <p>本站輔助教材書籍檔案與相關資源，僅供購買翰林輔助教材教師之教學合理使用。</p>
            <p>本站及其內容之任何部分，不得以任何方式加以複製、列印、下載、張貼、轉貼，請勿侵權違法。</p>
          </article>
       </footer>
    `
  }
  const createSubjectTemplate = () => {
    return `
      <link rel="stylesheet" href="../../../css/reset.css">
      <link rel="stylesheet" href="../../../css/header.css">
      <link rel="stylesheet" href="../../../css/all.css">
      <link rel="stylesheet" href="../../../css/table.css">
      <footer>
          <article>
            <ul>
              <li class="hle_logo">翰林出版</li>
              <li><a href="https://books.hanlin.com.tw/" target="_blank" class="bookTown">翰林書城</a> |</li>
              <li><a href="https://books.hanlin.com.tw/Dealer" target="_blank">經銷商據點</a> |</li>
              <li><a href="https://books.hanlin.com.tw/Version" target="_blank">版本查詢</a> |</li>
              <li><a href="https://url-m01d.hle.com.tw/footer-files" target="_blank">檔案下載區</a> |</li>
              <li><a href="https://url-m01d.hle.com.tw/footer-sample" target="_blank">試閱區</a> |</li>
              <li><a href="https://docs.google.com/document/d/1JmQQOWM73oQcBgpVU_ucfmvoNPkKtmenUG2_rMRs2Fs/edit?usp=sharing" target="_blank">勘誤補充</a> |</li>
              <li>
                <a href="https://www.facebook.com/hanlinppbox/"><span class="share_fb"></span></a>
              </li>
            </ul>
            <p><span>2023 Hanlin 翰林出版事業股份有限公司</span>
              <em class="v_nber">v3.0.1</em>
            </p>
            <p>本站輔助教材書籍檔案與相關資源，僅供購買翰林輔助教材教師之教學合理使用。</p>
            <p>本站及其內容之任何部分，不得以任何方式加以複製、列印、下載、張貼、轉貼，請勿侵權違法。</p>
          </article>
       </footer>
    `
  }

  customElements.define('el-footer', class extends HTMLElement {
    constructor() {
      super()
      this.attachShadow({ mode: 'open' })
    }

    connectedCallback(){
      const type = this.getAttribute("type")
      if (type === constant.FOOTER_TYPE.INDEX) {
        this.shadowRoot.innerHTML = createIndexTemplate()
      } else if (type === constant.FOOTER_TYPE.SUBJECT){
        this.shadowRoot.innerHTML = createSubjectTemplate()
      }
    }
  })
})()
